export default __webpack_public_path__ + "static/zhi-2-13cb1f3a1cec5831edb82fd84c8483b8.jpg";